<div id="mainContent" class="container">
    <button mat-raised-button class="btn-theme" style="float:right"
    matTooltip="Click to add assignment" matTooltipPosition="left"
    (click)="openModal('add')">
        <i class="fa fa-plus-square" aria-hidden="true"></i>&nbsp;&nbsp; Client
    </button>

<br><br>

</div>

    <div id="clientTable" class="animate__animated animate__fadeInLeft">
        <div class="col-md-10 offset-md-1" >
          <table class="table table-responsive-md table-sm">
            <thead class="">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Name</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let formObj of formObjList; index as i">
                <th scope="row">{{i+1}}</th>
                <td>{{formObj.name}}</td>
                <td>
                  <button class="btn btn-sm btn-outline-theme"  (click)="onEditClick(formObj)"
                  matTooltip="Click to edit" matTooltipPosition="above">
                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                  </button> &nbsp;&nbsp;

                  <button class="btn btn-sm btn-outline-danger" (click)="onDeleteClick(formObj)"
                  matTooltip="Click to delete" matTooltipPosition="above">
                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

<!-- class="col-md-10 offset-md-1" -->





<!-- Modal Template -->
<ng-template #modalContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt">
    <h5 class="modal-title" id="modal-basic-title">Client</h5>
  </div>
  <div class="modal-body">
    <div id="clientForm" style="padding: 0%;" class="" *ngIf="formStatus=='add'||formStatus=='edit'">
      <!-- <mat-card> -->
        <form [formGroup]="formObj" *ngIf ="!showChecklist">
        <div class="row col-md-12">
          <div class="col-md-4">
            <div class="form-group mb-0">
              <label class="mb-0">Name :</label>
              <input id="name" name="name" type="text" class="form-control form-control-xs" formControlName="name"
              [class.is-invalid]="formErrors.name && formSubmitted" matTooltip="{{formErrors.name}}" matTooltipPosition="above">
            </div>

            <div class="form-group mb-0">
              <label class="mb-0">Email :</label>
              <input id="email" name="email" type="email" class="form-control form-control-xs"
              formControlName="email"
              [class.is-invalid]="formErrors.email && formSubmitted" matTooltip="{{formErrors.email}}" matTooltipPosition="above">
            </div>

            <div class="form-group mb-0">
              <label class="mb-0">PAN :</label>
              <input id="pan" name="pan" type="text" class="form-control form-control-xs"
              formControlName="pan"
              [class.is-invalid]="formErrors.pan && formSubmitted" matTooltip="{{formErrors.pan}}" matTooltipPosition="above">
            </div>

            <div class="form-group mb-0">
              <label class="mb-0">Address :</label>
              <textarea style="overflow:auto;resize:none" rows="3" cols="20" id="address" name="address" type="text"
              class="form-control form-control-xs" formControlName="address"
              [class.is-invalid]="formErrors.address && formSubmitted" matTooltip="{{formErrors.address}}" matTooltipPosition="above">
              </textarea>
            </div>

          </div>

          <div class="col-md-4">
            <div class="form-group mb-0">
              <label class="mb-0">Alias :</label>
              <input id="alias" name="alias" type="text" class="form-control form-control-xs"
              formControlName="alias"
              [class.is-invalid]="formErrors.alias && formSubmitted" matTooltip="{{formErrors.alias}}" matTooltipPosition="above">
            </div>

            <div class="form-group mb-0">
              <label class="mb-0">Chargeable To Client :</label>
              <select class="form-control form-control-xs" id="chargeableToClient" name="chargeableToClient" type="text" class="form-control form-control-xs"
              formControlName="chargeableToClient"
              [class.is-invalid]="formErrors.chargeableToClient && formSubmitted" matTooltip="{{formErrors.chargeableToClient}}" matTooltipPosition="above">
              <option [value]="null">Select</option>
                <option *ngFor="let chargable of chargableToClientList" [ngValue]="chargable.value">{{ chargable.name }}</option>
              </select>

            </div>

            <div class="form-group mb-0">
              <label class="mb-0">GST Number :</label>
              <input id="gstNumber" name="gstNumber" type="text" class="form-control form-control-xs" formControlName="gstNumber"
              [class.is-invalid]="formErrors.gstNumber && formSubmitted" matTooltip="{{formErrors.gstNumber}}" matTooltipPosition="above">
            </div>

            <div class="form-group mb-0">
              <label class="mb-0">Principal Place Of Business :</label>
              <textarea style="overflow:auto;resize:none" rows="3" cols="20" id="principalPlaceOfBusiness" name="principalPlaceOfBusiness" type="text"
              class="form-control form-control-xs" formControlName="principalPlaceOfBusiness"
              [class.is-invalid]="formErrors.principalPlaceOfBusiness && formSubmitted" matTooltip="{{formErrors.principalPlaceOfBusiness}}" matTooltipPosition="above"></textarea>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group mb-0">
              <!-- {{formObj.controls.ediaryStatus.value}} -->
              <label class="mb-0">Ediary Status :</label>
              <select class="form-control form-control-xs" id="ediaryStatus" name="ediaryStatus" formControlName="ediaryStatus"
              [class.is-invalid]="formErrors.ediaryStatus && formSubmitted" matTooltip="{{formErrors.ediaryStatus}}" matTooltipPosition="above">
                <option [ngValue]="null">Select</option>
                <option *ngFor="let ediaryStatusObj of ediaryStatusList"
                [ngValue]="ediaryStatusObj">
                {{ ediaryStatusObj.name }}
              </option>
              </select>
            </div>

            <div class="form-group mb-0">
              <label class="mb-0">Legal Status :</label>
              <select class="form-control form-control-xs" id="legalStatus" name="legalStatus" formControlName="legalStatus"
              [class.is-invalid]="formErrors.legalStatus && formSubmitted" matTooltip="{{formErrors.legalStatus}}" matTooltipPosition="above">
              <option [value]="null">Select</option>
                <option *ngFor="let legalStatus of legalStatusList" [ngValue]="legalStatus">{{ legalStatus.name }}</option>
              </select>
            </div>

            <div class="form-group mb-0">
              <label class="mb-0">Branch :</label>
              <select class="form-control form-control-xs" id="branch" name="branch" formControlName="branch"
              [class.is-invalid]="formErrors.branch && formSubmitted" matTooltip="{{formErrors.branch}}" matTooltipPosition="above">
                <option [value]="null">Select</option>
                <option *ngFor="let branch of branchList" [ngValue]="branch">{{ branch.name }}</option>
              </select>
            </div>

            <div class="form-group mb-0">
              <label class="mb-0">Sector :</label>
              <select class="form-control form-control-xs" id="sector" name="sector" formControlName="sector"
              [class.is-invalid]="formErrors.sector && formSubmitted" matTooltip="{{formErrors.sector}}" matTooltipPosition="above">
                <option [value]="null">Select</option>
                <option *ngFor="let sector of sectorList" [ngValue]="sector">{{ sector.name }}</option>
              </select>
            </div>
          </div>
        </div>

        <hr style="margin: 1% 1%;">
        <div class="row col-md-12 mt-2">
          <div class="col-md-4">
            <button  type="button" class="btn btn-xs btn-theme" (click)="addPartnerButtonClick()"><i class="fa fa-plus-square-o" aria-hidden="true"></i> Partner</button>
          </div>
          <div class="col-md-4"> </div>
          <div class="col-md-4"> </div>
        </div>
        <hr style="margin: 1% 1%;">
        <div id="location-container">
        <div formArrayName="partners"  *ngFor="let partner of formObj.get('partners').controls; let i = index">
          <div class="row col-md-12" [formGroupName]="i">
            <div class="col-md-4">
              <div class="form-group mb-0">
                <label class="mb-0">Partner :</label>
                <select class="form-control form-control-xs" [id]="'id_'+i" [name]="'id_'+i" formControlName="id"
                [class.is-invalid]="partner.get('id').errors?.required  && formSubmitted" matTooltip="{{formErrors.id}}" matTooltipPosition="above">
                  <option value="">Select</option>
                  <option *ngFor="let partner of partnerList" [ngValue]="partner.id">{{ partner.firstName }} {{ partner.middleName }} {{ partner.lastName }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-0">
                <!-- <label class="mb-0">Assignments :</label> -->
                <mat-form-field appearance="legacy" style="width:300px;" >
                  <mat-label>Assignments</mat-label>
                  <mat-select formControlName="assignments" multiple [compareWith]="compareItems">
                    <mat-option #item *ngFor="let assignment of assignmentList" [value]="assignment" [disabled]="assignment.disabled">
                      {{assignment.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <span *ngIf="partner.get('assignments').errors?.incorrect && formSubmitted" class="text-danger">Invalid assignments</span>
              </div>
            </div>
            <div class="col-md-1">
              <button  type="button" class="btn btn-sm btn-outline-danger mt-3" (click)="removePartnerButtonClick(i)">
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <hr style="margin: 1% 1%;">
        <div class="row col-md-12 mt-2">
          <div class="col-md-4">
            <button  type="button" class="btn btn-xs btn-theme" (click)="addLocationButtonClick()"><i class="fa fa-plus-square-o" aria-hidden="true"></i> Location</button>
          </div>
          <div class="col-md-4"> </div>
          <div class="col-md-3"> </div>
          <div class="col-md-1"> </div>
        </div>
        <hr style="margin: 1% 1%;">
        <div id="location-container">
          <div formArrayName="clientLocations"  *ngFor="let location of formObj.get('clientLocations').controls; let i = index">
            <div class="row col-md-12" [formGroupName]="i">
              <div class="col-md-4">
                <div class="form-group mb-0">
                  <label class="mb-0">Location :</label>
                  <select class="form-control form-control-xs" [id]="'id_'+i" [name]="'id_'+i" formControlName="id"
                  [class.is-invalid]="location.get('id').errors?.required  && formSubmitted" matTooltip="{{formErrors.id}}" matTooltipPosition="above">
                    <option value="">Select</option>
                    <option *ngFor="let location of locationList" [ngValue]="location.id">{{ location.name }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-0">
                  <label class="mb-0">Distance :</label>
                  <input id="distance" name="distance" type="text" class="form-control form-control-xs" formControlName="distance"
                  [class.is-invalid]="location.get('distance').errors?.required && formSubmitted" matTooltip="{{formErrors.distance}}" matTooltipPosition="above">
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-0">
                  <label class="mb-0">Amount :</label>
                  <input id="amount" name="amount" type="text" class="form-control form-control-xs" formControlName="amount"
                  [class.is-invalid]="location.get('amount').errors?.required && formSubmitted" matTooltip="{{formErrors.amount}}" matTooltipPosition="above">
                </div>
              </div>
              <div class="col-md-1">
                <button  type="button" class="btn btn-sm btn-outline-danger mt-3" (click)="removeClientLocationButtonClick(i)">
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="row col-md-12">
          <div class="col-md-4"> </div>
          <div class="col-md-4"> </div>
          <div class="col-md-4"> </div>
        </div> -->

      </form>
      <!-- </mat-card> -->
      <div id="checklistDiv" *ngIf="showChecklist">
        <form [formGroup]="clientChecklistForm">
          <ngb-tabset #tabsetChecklist="ngbTabset" [destroyOnHide]="false">
            <ngb-tab id="tab-selectbyid_{{i}}"
            title="{{client.value.assignment.name}}"
            formArrayName="clientAssignment"
            *ngFor="let client of clientChecklistForm.get('clientAssignment').controls; let i = index">
            <ng-template ngbTabContent [formGroupName]="i">
              <div class="container border">

                <div class="row col-md-12 m-0 p-0">
                  <div class="row col-md-12 m-0 p-0 border">
                    <div class="row col-md-12">
                      <div class="col-md-12 p-2">
                        <h6 style="font-weight: bold;text-align: center;">Client Acceptance Checklist</h6>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row col-md-12 m-0 p-0 " >
                  <div class="row col-md-12 m-0 p-0 border">
                    <div class="col-md-1 right-border" style="max-width:5%;font-weight: bold;padding:0px;">Sr.No</div>
                    <div class="col-md-7 right-border" style="font-weight: bold;">Identification of Risk / Problem Areas</div>
                    <div class="col-md-1 right-border" style="font-weight: bold;">Yes/No</div>
                    <div class="col-md-3" style="font-weight: bold;">Remark</div>
                  </div>
                </div>

                <div class="row col-md-12 m-0 p-0" formArrayName="clientAssignmentChecklist"
                *ngFor="let checklist of client.get('clientAssignmentChecklist').controls; let j = index">
                    <div class="row col-md-12 m-0 p-0 border" [formGroupName]="j" >
                    <div class="col-md-1 right-border" style="max-width:5%;text-align: center;font-weight: bold;padding:0px;">{{j+1}}</div>
                    <div class="col-md-7 right-border">{{checklist.value.question}}</div>
                    <div class="col-md-1 right-border">
                      <input type="checkbox" id="isRequired_{{i}}_{{j}}" name="isRequired_{{i}}_{{j}}"
                      class="mt-2"
                      formControlName='isRequired'></div>
                    <div class="col-md-3">
                      <input type="text" id="remark_{{i}}_{{j}}" name="remark_{{i}}_{{j}}"
                      class="form-control form-control-xs mt-1 mb-1"
                      formControlName='remark'></div>
                    </div>
                  </div>

                  <div class="row col-md-12 m-0 p-0">
                    <div class="row col-md-12 m-0 p-0 border">
                      <div class="row col-md-12">
                        <div class="col-md-12"><h6 style="font-weight: bold;">OVERALL CONCLUSION:</h6></div>
                      </div>
                      <div class="row col-md-12">
                        <div class="col-md-12">Based on the comments as noted above, we conclude that the engagement can be accepted</div>
                      </div>
                      <div class="row col-md-12">
                        <div class="col-md-4" style="font-weight: bold;">Sign :</div>
                        <div class="col-md-5"><input type="checkbox" id="isSign_{{i}}" name="isSign_{{i}}" class="mt-2" formControlName='isSign'></div>
                      </div>
                      <div class="row col-md-12 ">
                        <div class="col-md-4" style="font-weight: bold;">Engagaement Partner name :</div>
                        <div class="col-md-5" style="color: red;">{{client.get('partner').value}}
                        </div>
                      </div>
                      <div class="row col-md-12">
                        <div class="col-md-4" style="font-weight: bold;">Date :</div>
                        <div class="col-md-5" style="color: red;">{{client.get('signDate').value | date: 'dd-MM-yyyy'}}
                        </div>
                      </div>
                    </div>
                  </div>

              </div>



            </ng-template>
          </ngb-tab>
          </ngb-tabset>
        </form>
      </div>
    </div>
  </div>

  <div class="modal-footer" style="">
    <div class="row col-md-12">
        <div class="col-sm-6"></div>
        <div class="col-sm-2">
            <button type="button"  class="btn btn-sm btn-block btn-outline-secondary" (click)="closeModal()">Close</button>
        </div>
        <div class="col-sm-2">
          <button type="button" [disabled]="!((formStatus=='add' || formStatus=='edit') && showChecklist)" class="btn btn-sm btn-block btn-outline-secondary" (click)="onBackBtnClick()"><i class="fa fa-arrow-left" aria-hidden="true"></i> Back</button>
        </div>
        <div class="col-sm-2">
            <button  type="button" *ngIf="(formStatus=='add' || formStatus=='edit') && !showChecklist" class="btn btn-sm btn-block btn-outline-theme" (click)="onOkBtnClick()">Next <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
            <!-- <button  type="button" *ngIf="formStatus=='add' && showChecklist" class="btn btn-sm btn-block btn-outline-theme" (click)="onSaveClick()">Save </button> -->
            <!-- <button  type="button" *ngIf="modalStatus=='edit'" class="btn btn-sm btn-block btn-outline-theme" (click)="onUpdateClick()">Update</button> -->
        </div>
    </div>
</div>
</ng-template>


<!-- Modal Template -->
<!-- <ng-template #modalChecklistContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt">
    <h5 class="modal-title" id="modal-basic-title">Checklist</h5>
  </div>
  <div class="modal-body">
    <div id="clientChecklistForm" style="padding: 0%;" class="">

    </div>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
        <div class="col-sm-6"></div>
        <div class="col-sm-3">
            <button type="button" class="btn btn-sm btn-block btn-outline-secondary" (click)="modal.dismiss('Cross click')">Close</button>
        </div>
        <div class="col-sm-3">
            <button  type="button" *ngIf="formStatus=='add'" class="btn btn-sm btn-block btn-outline-theme" (click)="onSaveClick()">Save</button>
            <button  type="button" *ngIf="modalStatus=='edit'" class="btn btn-sm btn-block btn-outline-theme" (click)="onUpdateClick()">Update</button>
        </div>
    </div>
</div>
</ng-template> -->
